"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.x = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const x = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'x-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', 
            // eslint-disable-next-line max-len
            d: 'M2.53033 2.46967C2.82322 2.17678 3.2981 2.17678 3.59099 2.46967L10 8.87868L16.409 2.46967C16.7019 2.17678 17.1768 2.17678 17.4697 2.46967C17.7626 2.76256 17.7626 3.23744 17.4697 3.53033L11.0607 9.93934L17.5303 16.409C17.8232 16.7019 17.8232 17.1768 17.5303 17.4697C17.2374 17.7626 16.7626 17.7626 16.4697 17.4697L10 11L3.53033 17.4697C3.23744 17.7626 2.76256 17.7626 2.46967 17.4697C2.17678 17.1768 2.17678 16.7019 2.46967 16.409L8.93934 9.93934L2.53033 3.53033C2.23744 3.23744 2.23744 2.76256 2.53033 2.46967Z', fill: '#4B5563' })));
};
exports.x = x;
